export default "__VITE_ASSET__6c7BOxPQ__"